export default {
    methods: {
        hasData(object){
            if(!Object.keys(object).length){
                return false;
            }
            return true;          
         },      
    }
}